import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';
import EstateTypeLang from '/@/modules/estate/services/EstateTypeLang';

export class IncomeType extends Enum {
  static WORK = {
    key: 'work',
    get value() {
      return Lang.t('asset.work-income');
    },
    get description() {
      return Lang.t('asset.income-of-occupation');
    }
  };

  static DIVIDEND = {
    key: 'dividend',
    get value() {
      return Lang.t('asset.dividend-income');
    },
    get description() {
      return Lang.t('asset.paid-corporation-the');
    }
  };

  static INTEREST = {
    key: 'interest',
    get value() {
      return Lang.t('asset.interest-income');
    },
    get description() {
      return Lang.t(
        'asset.generated-accounts-that'
      );
    }
  };

  static RENTAL = {
    key: 'rental',
    get value() {
      return Lang.t('asset.rental-income');
    },
    get description() {
      return EstateTypeLang.rentalIncomeDescription;
    }
  };

  static TAX_REFUND = {
    key: 'tax_refund',
    get value() {
      return Lang.t('asset.tax-income');
    }
  };

  static getAvailableValues() {
    return this.getValues().filter((value) => value.key !== IncomeType.TAX_REFUND.key);
  }
}
